import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { titleize } from 'underscore.string';
import { Button, Alert, FormGroup, FormControl, ControlLabel, Modal } from 'react-bootstrap';
import validator from 'email-validator';
import { withTranslation } from 'react-i18next';

class SendEmailModal extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    onSend: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState() {
    return {
      error: null,
      to: '',
    };
  }

  componentWillUnmount() {
    this.setState(this.getInitialState());
  }

  addRecipients(e) {
    this.setState({ to: e.target.value.trim() });
  }

  send = () => {
    const {t} = this.props;
    const emails = this.state.to.replace(/' '/g, '').split(',');
    const invalidEmailAddresses = emails.filter(ea => !validator.validate(ea));
    if (invalidEmailAddresses.length > 0) {
      this.setState({ error: t('VALID_EMAIL_ONLY') });
    }
    else {
      this.props.onSend(_.uniq(emails));
      this.setState(this.getInitialState());
      this.props.onHide(); 
    }
  }

  renderError() {
    if (!this.state.error) {
      return '';
    }
    return (
      <Alert bsStyle="warning">{this.state.error}</Alert>
    );
  }

  render() {
    const {t} = this.props;
    return (
      (<Modal show={this.props.show} onHide={this.props.onHide} enforceFocus={false}>
        <Modal.Header data-testid="undefined-26e78579">
          <strong data-testid="strong-a5b27bb3">{t('EMAIL_THIS_INVOICE')}</strong>
        </Modal.Header>
        <Modal.Body data-testid="undefined-0c58f686">
          {this.renderError()}
          <div data-testid="div-862b324b">
            <FormGroup>
              <ControlLabel data-testid="undefined-26e78580">{titleize(t('RECIPIENT', {count: 1}))}</ControlLabel>
              <FormControl data-testid="undefined-26e78581" onChange={e => this.addRecipients(e)} type="text" value={this.state.to} />
            </FormGroup>
          </div>
        </Modal.Body>
        <Modal.Footer data-testid="undefined-700c8c8a">
          <Button data-testid="Button-26e78579" bsStyle="danger" type="button" onClick={this.props.onHide}>{titleize(t('CLOSE'))}</Button>
          <Button data-testid="Button-26e78902" disabled={this.state.to === ''} bsStyle="primary" type="button" onClick={this.send}>{t('SEND')}</Button>
        </Modal.Footer>
      </Modal>)
    );
  }
}

export default withTranslation()(SendEmailModal)